import { API_ROUTES } from "../../../shared/api/routes"
import baseApi from "../baseApi"

const buildBundleUrl = (endpoint) =>
  `${API_ROUTES.BOOK.BASE}${API_ROUTES.BOOK.BUNDLE}/${endpoint ? endpoint : ""}`

export const buildBundleExportUrl = (typeView, filters = {}) => {
  const params = new URLSearchParams()
  params.append("type_view", typeView)

  Object.entries(filters).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return
    if (Array.isArray(value)) {
      if (value.length === 0) return
      value.forEach((v) => params.append(`${key}[]`, v))
    } else {
      params.append(key, value)
    }
  })

  return `${buildBundleUrl("export")}?${params.toString()}`
}

export const bundleService = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    reserveBundle: builder.query({
      query: (params) => ({
        url: buildBundleUrl("new_optim"),
        method: "GET",
        params: params,
      }),
    }),
    getOptimUrl: builder.query({
      query: (params) => ({
        url: buildBundleUrl("new_optim_url"),
        method: "GET",
        params: params,
      }),
    }),
    getBundleColumns: builder.query({
      query: () => ({
        url: buildBundleUrl("columns"),
        method: "GET",
      }),
      providesTags: ["BundleColumns"],
    }),
    updateBundleColumns: builder.mutation({
      query: ({ order }) => ({
        url: buildBundleUrl("update_columns"),
        method: "PATCH",
        body: { order },
      }),
      invalidatesTags: ["BundleColumns"],
    }),
    applyColumnTemplate: builder.mutation({
      query: ({ templateId }) => ({
        url: buildBundleUrl("columns/apply_template"),
        method: "PATCH",
        body: { template_id: templateId },
      }),
      invalidatesTags: ["BundleColumns"],
    }),

    getBundles: builder.query({
      query: ({ columns, page = 1, perPage, filters = {}, activeStatus = null }) => ({
        url: buildBundleUrl("index_data"),
        method: "GET",
        params: {
          columns,
          page,
          ...(perPage ? { per_page: perPage } : {}),
          ...filters,
        },
      }),
    }),
    getFilterOptions: builder.query({
      query: () => ({
        url: buildBundleUrl("filter_options"),
        method: "GET",
      }),
    }),
    bulkUpdateBundleStatus: builder.mutation({
      query: ({ bundleIds, statusId, cancellationReasonId }) => ({
        url: buildBundleUrl("bulk_update_status"),
        method: "POST",
        body: {
          bundle_ids: bundleIds,
          status_id: statusId,
          ...(cancellationReasonId ? { bundle_cancellation_reason_id: cancellationReasonId } : {}),
        },
      }),
    }),
    bulkDeleteBundles: builder.mutation({
      query: ({ bundleIds }) => ({
        url: buildBundleUrl("bulk_destroy"),
        method: "POST",
        body: { bundle_ids: bundleIds },
      }),
    }),
    getColumnTemplates: builder.query({
      query: () => buildBundleUrl("column_templates"),
      providesTags: ["ColumnTemplates"],
    }),
    createColumnTemplate: builder.mutation({
      query: (body) => ({
        url: buildBundleUrl("column_templates"),
        method: "POST",
        body: {
          template: {
            name: body.name,
            description: body.description,
            department_id: body.department_id,
            columns: { visible: body.visible, order: body.order },
          },
        },
      }),
      invalidatesTags: ["ColumnTemplates"],
    }),
    updateColumnTemplate: builder.mutation({
      query: ({ id, ...body }) => ({
        url: buildBundleUrl(`column_templates/${id}`),
        method: "PATCH",
        body: {
          template: {
            name: body.name,
            description: body.description,
            department_id: body.department_id,
            columns: { visible: body.visible, order: body.order },
          },
        },
      }),
      invalidatesTags: ["ColumnTemplates", "BundleColumns"],
    }),
    deleteColumnTemplate: builder.mutation({
      query: (id) => ({
        url: buildBundleUrl(`column_templates/${id}`),
        method: "DELETE",
      }),
      invalidatesTags: ["ColumnTemplates", "BundleColumns"],
    }),

    getColumnTemplateDepartments: builder.query({
      query: () => buildBundleUrl("column_templates/departments"),
    }),
  }),
})

export const {
  useLazyReserveBundleQuery,
  useLazyGetOptimUrlQuery,
  useGetBundleColumnsQuery,
  useUpdateBundleColumnsMutation,
  useApplyColumnTemplateMutation,
  useGetBundlesQuery,
  useLazyGetBundlesQuery,
  useGetFilterOptionsQuery,
  useLazyGetFilterOptionsQuery,
  useBulkDeleteBundlesMutation,
  useBulkUpdateBundleStatusMutation,
  useCreateColumnTemplateMutation,
  useDeleteColumnTemplateMutation,
  useUpdateColumnTemplateMutation,
  useGetColumnTemplatesQuery,
  useGetColumnTemplateDepartmentsQuery,
  useLazyGetBundleColumnsQuery,
} = bundleService
